<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center" class="d-flex">
      <v-col cols="12" class="text-center">
        <h1>Ой, а нет такой страницы.</h1>
        <h3 class="pb-7">Даже интересно, как вы сюда попали?</h3>
        <p>
          Попробуйте найти то, что искали через верхнее меню. Если не получится,
          то пишите нам, будем искать вместе.
        </p>
      </v-col></v-row
    ></v-container
  >
</template>

<script>
export default {}
</script>

<style></style>
